import { render, staticRenderFns } from "./ModalBase.vue?vue&type=template&id=71ca45fa&scoped=true"
import script from "./ModalBase.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalBase.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ModalBase.vue?vue&type=style&index=0&id=71ca45fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ca45fa",
  null
  
)

export default component.exports